export default "__VITE_ASSET__aJAN$wpf__"